// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1238":"06b061d3","3542":"83e7dd1f","4638":"7dfa556b","7207":"7dfa556b","7234":"1951ab28","7273":"dd23afcf"}[chunkId] + ".chunk.css";
};